import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from '../network/Configurations';

const addProjectCategory = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.post(API_URL.ADD_PROJECT_CATEGORY, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const updateProjectCategory = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.UPDATE_PROJECT_CATEGORY, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const deleteProjectCategory = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.delete(API_URL.DELETE_PROJECT_CATEGORY, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getProjectCategoryById = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_PROJECT_CATEGORY, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

const getProjectCategoryList = (): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_PROJECT_CATEGORY_LIST)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    console.log(error.response);
                    reject(error);
                })
        );
    });
}

export const ProjectCategoryService = {
    addProjectCategory,
    updateProjectCategory,
    deleteProjectCategory,
    getProjectCategoryById,
    getProjectCategoryList
}